import React, { Component } from "react";
import { graphql, StaticQuery } from "gatsby";
import { ISettings } from "resource-centre-theme/src/models";
import * as s from "./Footer.module.scss";
import { inject, observer } from "mobx-react";
import { LanguageStore } from "resource-centre-theme/src/stores";
import { DynamicLink } from "resource-centre-theme/src/views/shared/components/DynamicLink";
import { BackgroundImage } from "resource-centre-theme/src/views/shared/components";

interface Props {
  settings: ISettings;
  languageStore?: LanguageStore;
}

@inject("languageStore")
@observer
export class FooterLogoComponent extends Component<Props> {
  render() {
    const { settings, languageStore } = this.props;
    const { selectedLanguage } = languageStore;
    const { themeSettings } = settings;
    const { themeSettingsFields } = themeSettings;
    const { footerLogo, resourceCentreUrl } = themeSettingsFields;

    return (
      <DynamicLink to={resourceCentreUrl} className={s.logoWrapper}>
        <div className={s.logo}>
          <BackgroundImage image={footerLogo} objectFit="scale-down" />
        </div>
        <div className={s.logoTitle}>
          <p>Child Rights Resource centre</p>
        </div>
      </DynamicLink>
    );
  }
}

export const FooterLogo = (props: ISettings) => (
  <StaticQuery
    query={query}
    render={(data) => (
      <FooterLogoComponent {...props} settings={data.siteSettings} />
    )}
  />
);

const query = graphql`
  query {
    ...siteSettingsFragmentExtended
  }
`;
